
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/relax",
      function () {
        return require("private-next-pages/relax.js");
      }
    ]);
  